import React, {useState} from "react";
import {Checkbox, Form} from "antd";
import CodeInput from "./CodeInput";
import Button from "@common/Button";

const AccountSettingsRenewProductActivationKey = props => {
    const {data, checkFormStatus, handleSubmitForm} = props;
    const [submittable, setSubmittable] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [form] = Form.useForm();

    const handleSubmitFormWrapper = async (values) => {
        form.setFields(Object.keys(form.getFieldsValue()).map(name => ({name, errors: []})));

        const validatedValues = await form.validateFields();

        setDisabled(true);
        handleSubmitForm(form, validatedValues, {}, "/web/ui/accountSettings/activateProduct", () => {
            setDisabled(false);
            displayToastMessage("Product added", "", "success", undefined, 4000);
            form.setFieldValue('activationKey', '');
        }, () => {
            setDisabled(false);
        });
    };

    return (
        <Form
            form={form}
            layout="vertical"
            onFieldsChange={() => setSubmittable(checkFormStatus(form))}
            onFinish={handleSubmitFormWrapper}
            initialValues={{
                terms: false
            }}
        >
            <Form.Item
                label="Enter your activation key"
                name="activationKey"
                rules={[
                    { required: true, message: "Please enter your activation key" },
                    {
                        validator: (_, value) =>
                            value && value.replace(/\s/g, "").length === 16
                                ? Promise.resolve()
                                : Promise.reject("Activation key must be 16 characters"),
                    }
                ]}
                validateTrigger="onBlur"
            >
                <CodeInput
                    allowedCharacters={/[^A-Z0-9]/gi}
                    delimiter="-"
                    segmentLength={4}
                    totalSegments={4}
                />
            </Form.Item>
            <Form.Item
                name="terms"
                valuePropName="checked"
                rules={[
                    {
                        validator: (_, value) =>
                            value ? Promise.resolve() : Promise.reject(new Error('Please accept the terms and conditions')),
                    }
                ]}
                validateTrigger="onBlur"
            >
                <Checkbox>I accept the terms and conditions</Checkbox>
            </Form.Item>
            <Form.Item>
                <Button type="primary" htmlType="submit" disabled={disabled ? disabled : !submittable}>
                    Activate
                </Button>
            </Form.Item>
        </Form>
    )
}

export default AccountSettingsRenewProductActivationKey;